import { Card } from '@bancobarigui/barihaus';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { ProviderComparison } from '../types';
import { getStatusColor, getStatusLabel } from '../utils/chartColors';
import { EmptyState } from './EmptyState';

ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend);

interface ProviderComparisonChartProps {
  data: ProviderComparison[];
  loading?: boolean;
  title?: string;
}

export function ProviderComparisonChart({ data, loading = false, title = 'Comparativo entre prestadoras' }: ProviderComparisonChartProps) {
  
  const allStatuses = new Set<string>();
  data.forEach(provider => {
    Object.keys(provider.statusCounts).forEach(status => allStatuses.add(status));
  });
  const statusArray = Array.from(allStatuses);

  
  const barDatasets = statusArray.map(status => ({
    type: 'bar' as const,
    label: getStatusLabel(status),
    data: data.map(provider => provider.statusCounts[status] || 0),
    backgroundColor: getStatusColor(status),
    borderRadius: 4,
    yAxisID: 'y',
  }));

  
  const lineDataset = {
    type: 'line' as const,
    label: 'Tempo Médio (dias)',
    data: data.map(item => item.averageCompletionTime),
    borderColor: '#13c2c2',
    backgroundColor: 'rgba(19, 194, 194, 0.2)',
    borderWidth: 2,
    tension: 0.4,
    yAxisID: 'y1',
  };

  const chartData = {
    labels: data.map(item => item.name),
    datasets: [...barDatasets, lineDataset],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index' as const,
      intersect: false,
    },
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          usePointStyle: true,
          padding: 15,
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        type: 'linear' as const,
        display: true,
        position: 'left' as const,
        beginAtZero: true,
        title: {
          display: true,
          text: 'Quantidade de Vistorias',
        },
      },
      y1: {
        type: 'linear' as const,
        display: true,
        position: 'right' as const,
        beginAtZero: true,
        title: {
          display: true,
          text: 'Tempo Médio (dias)',
        },
        grid: {
          drawOnChartArea: false,
        },
      },
    },
  };

  const hasData = data && data.length > 0;

  return (
    <Card title={title} bordered={false} loading={loading} style={{ height: '100%' }}>
      {!hasData ? (
        <EmptyState />
      ) : (
        <div style={{ height: '350px' }}>
          <Bar data={chartData as any} options={options} />
        </div>
      )}
    </Card>
  );
}
